import { Route, Routes, Navigate } from "react-router-dom";
import HomePage from "pages/homePage";
import UserProfile from "pages/userProfile";
import SupplyAndDemand from "pages/supplyDemand";
import SmartRepair from "pages/smartRepair";
import PropTypes from "prop-types";
import Emptystate from "components/emptyState";
import constants from "../constants/constants.json";

export const AppRoutes = ({ isNavbarOpen }) => {
  return (
    <Routes>
      <Route path={"/"} element={<HomePage isNavbarOpen={isNavbarOpen} />} />
      <Route
        path={"/profile"}
        element={<UserProfile isNavbarOpen={isNavbarOpen} />}
      />
      <Route
        path={"/smart-repair"}
        element={<SmartRepair isNavbarOpen={isNavbarOpen} />}
      />
      <Route
        path="/overview/entry/:pid/:fid?/:tid?/*"
        element={<SupplyAndDemand isNavbarOpen={isNavbarOpen} />}
      />
      <Route
        path="/forbidden"
        element={
          <Emptystate
            title={constants.forbidden}
            message={constants.unauthorizedMessage}
            isNavbarOpen={isNavbarOpen}
            isErrorPage
          />
        }
      />
      <Route
        path="/unauthorized"
        element={
          <Emptystate
            title={constants.unauthorized}
            message={constants.unauthorizedMessage}
            isNavbarOpen={isNavbarOpen}
            isErrorPage
          />
        }
      />
      <Route
        path="/notfound"
        element={
          <Emptystate
            title={constants.notFound}
            message={constants.notFoundMessage}
            isNavbarOpen={isNavbarOpen}
            isErrorPage
          />
        }
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

AppRoutes.propTypes = {
  isNavbarOpen: PropTypes.bool,
};
